import React, { useEffect, useState } from "react";
import { getSiteVisitCount } from "./visitTracker";

export default function VisitorCounter() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    let mounted = true;

    getSiteVisitCount().then((count) => {
      if (mounted && count !== null) {
        setTotal(count);
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  if (total === null) {
    return null;
  }

  return (
    <p className="visitor-counter">
      Total Visitors:{" "}
      <strong>{total.toLocaleString()}</strong>
    </p>
  );
}
